var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8945 10.4728C71.1899 23.3824 71.5071 44.638 58.6088 57.9461C45.7048 71.2534 24.4765 71.5705 11.1813 58.6611C-2.10806 45.7512 -2.43108 24.4956 10.467 11.1877C23.3644 -2.11298 44.5991 -2.43036 57.8945 10.4728Z",
    fill: "#FEFEFE",
    stroke: "#FF8C0B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 49.9476C42.9792 49.9476 49.9167 43.0038 49.9167 34.5169C49.9167 26.03 42.9792 19.0862 34.5 19.0862C26.0209 19.0862 19.0834 26.03 19.0834 34.5169C19.0834 43.0038 26.0209 49.9476 34.5 49.9476Z",
    stroke: "#FF8C0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9479 34.5169L32.3108 38.8838L41.052 30.15",
    stroke: "#FF8C0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2On);
export default __webpack_public_path__ + "static/media/2_on.823eac9b1524999d1bd908e085112b1c.svg";
export { ForwardRef as ReactComponent };